/**
 * Date utility functions - GB Location
 */

/**
 * Add months to a date
 * @param {Date|string} date - Starting date
 * @param {number} months - Months to add
 * @returns {string} YYYY-MM-DD format
 */
export const addMonths = (date, months) => {
  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  // FIXED: toISOString() is UTC — use local date parts for London timezone
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

/**
 * Get today's date in YYYY-MM-DD format
 * @returns {string}
 */
export const getTodayDate = () => {
  // FIXED: toISOString() is UTC — use local date parts for London timezone
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

/**
 * Get Monday of current week
 * @returns {Date}
 */
export const getMondayOfCurrentWeek = () => {
  const today = new Date();
  const day = today.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  const monday = new Date(today);
  monday.setDate(today.getDate() + diff);
  monday.setHours(0, 0, 0, 0);
  return monday;
};

/**
 * Format date to DD-MM-YYYY (GB format)
 * @param {Date|string} date
 * @returns {string}
 */
export const formatDateGB = (date) => {
  return new Date(date).toLocaleDateString('en-GB').replace(/\//g, '-');
};